import { useRefreshPartFilesOnError } from 'common/Hooks/useRefreshPartFilesOnError'
import PropTypes from 'prop-types'
import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'

/**
 * @param {Omit<import('react').ImgHTMLAttributes, 'src'> & { partId: number }} args
 */
const PartImg = ({ partId, ...imgProps }) => {

	// get image from redux store:
	const thumbnail = useSelector(state =>
		(/** @type {StoreState} */(state)
			.CloudStorage.partsFiles?.parts
			?.find(p => parseInt(p.id) === partId)
			?.fileLinks
			?.thumbnail)
	)

	// refresh image if needed:
	const { onLoadPartFileError } = useRefreshPartFilesOnError(partId)
	useEffect(() => {
		if (thumbnail == null) {
			onLoadPartFileError()
		}
	}, [thumbnail, onLoadPartFileError])

	// no thumbnail -> show 'no image' icon:
	if (thumbnail == null) return (
		<p
			{...imgProps}
			className='fs-2 m-0'
			>
				<i className='bx bx-camera-off'></i>
		</p>
	)

	// show image:
	return (
		<img
			{...imgProps}
			src={thumbnail}
			onError={onLoadPartFileError}
		/>
	)
}

PartImg.propTypes = {
	partId: PropTypes.number,
}

export default PartImg